import { ListTodo, Plus } from 'lucide-react';
import { SummaryPanel } from './SummaryPanel';
import { summaryDate } from './formatters';

export const TasksSummary = ({ section, today, onEdit }) => {
    const data = section.data;
    return <SummaryPanel id="home-tasks" title="Prioridades del equipo" icon={ListTodo} href="/tasks?time=week"
        question="¿Quién hará qué y para cuándo?" section={section}>
        {data && <>
            <div className="home-week-task-totals"><span>{data.overdue} vencidas</span><span>{data.upcoming} por hacer esta semana</span><span>{data.undated} sin fecha</span></div>
            <p className="home-week-hint">Tareas existentes, con vencidas primero. Abre una tarea para acordar responsable, fecha y estado.</p>
            {data.next.length ? <ul className="home-week-list home-week-tasks">{data.next.map(task => <li key={task.id}>
                <button type="button" className="home-week-task-link" onClick={() => onEdit(task.id)}>{task.nombre || 'Sin nombre'}</button>
                <small>{task.project || 'Tarea general'} · {task.responsible} · {summaryDate(task.due)}</small>
                <span className={`home-week-badge ${task.due && task.due < today ? 'home-week-badge-alert' : ''}`}>
                    {task.due && task.due < today ? 'Vencida' : task.estado || 'Por hacer'}{task.tipo === 'hito' ? ' · Hito' : ''}
                </span>
            </li>)}</ul> : <p className="home-week-empty">No hay tareas vencidas, sin fecha o próximas hasta el domingo. Crea los acuerdos de tu reunión.</p>}
            <button type="button" className="home-week-button" onClick={() => onEdit(0)}><Plus size={16} aria-hidden="true" />Nueva tarea / acuerdo</button>
        </>}
    </SummaryPanel>;
};
